import { defineStore } from 'pinia'

type TStoreType = {
  interacted: Boolean
};

const events = ['click', 'touchend']

// registers the first user interaction with the DOM (to unmute videos)
export const useInteractionStore = defineStore('interaction', {
  state: (): TStoreType => {
    return {
      interacted: false
    }
  },
  actions: {
    setListeners () {
      events.forEach((eventName) => {
        window.addEventListener(eventName, this.setInteracted)
      })
    },
    setInteracted () {
      if (!this.$state.interacted) {
        this.$state.interacted = true
        this.clearListeners()
      }
    },
    clearListeners () {
      events.forEach((eventName) => {
        window.removeEventListener(eventName, this.setInteracted)
      })
    }
  },
  getters: {
    getInteracted: state => state.interacted
  }
})
